import { useNavigate } from "react-router-dom";

import { useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

import { BusinessService } from "../../3.Interfaces/Services";

export const useHandleBusinessService = () => {
  const { session } = useSession();
  const navigate = useNavigate();
  if (!session) {
    navigate("/signin", { replace: true });
  }
  const userid = session.user.id;
  const token = session.user.token;

  const createService = async (businessId: number, data: BusinessService) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      action: "addservice",
      data: JSON.stringify(data),
    };

    console.log("DATA IS", JSON.stringify(data));

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/services.php?${queryString}`);

      console.log(response);
      return response.data.id;
    } catch (error) {
      console.error(error);
    }
  };

  const getAllServices = async (businessId: number) => {
    const payloadForQuery: Record<string, any> = {
      id: userid,
      token: token ?? "",
      businessid: businessId,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/services.php?${queryString}`);
      return response.data.data as BusinessService[];
    } catch (error) {
      console.error(error);
    }
  };

  const updateService = async (businessId: number, data: BusinessService) => {
    const payloadForQuery: Record<string, any> = {
      id: userid,
      token: token ?? "",
      businessid: businessId,
      data: data,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/services.php?${queryString}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };
  return { createService, getAllServices, updateService };
};
